<template>
  <mfc-input-box :errors="cmpErrors">
    <div ref="dropArea"
         row=""
         wrap=""
         class="drop-area"
         :class="{highlight, uploading, 'show': showOnly, 'with-img': imgSrc, 'with-error': withError}"
         @click="imgSrc && showOnly ? false : $refs.file.click()"
         @dragenter.stop.prevent="startDrag"
         @dragover.stop.prevent="startDrag"
         @dragleave.stop.prevent="stopDrag"
         @drop.stop.prevent="handleDrop">
      <span class="label" v-if="!imgSrc">{{label}}</span>
      <div class="remove-logo-icon" @click="removeDepartmentLogo" v-if="imgSrc"><i class="mfcicon-cancel"></i></div>
      <div class="icon" row="cn" v-if="!imgSrc"><i class="mfcicon-add-calendar"></i></div>
      <img :src="imgSrc" v-if="imgSrc" alt="attachment">
      <input type="file"
             ref="file"
             accept="image/*"
             v-if="!showOnly"
             @change="handleFile($event.target.files)"
             :disabled="uploading || attrs.disabled"
             v-bind="fileInputAttrs">
      <input type="hidden"
             v-if="!showOnly"
             :value="cmpValue"
             :name="name"
             ref="resource_id">
    </div>
  </mfc-input-box>
</template>

<script>
  import MfcInputBox from './MfcInputBox'
  import first from 'lodash/first'
  import isEmpty from 'lodash/isEmpty'
  import inputMixin from "../../mixins/inputMixin"

  export default {
    name: "MfcAttachmentUpload",
    mixins: [inputMixin],
    components: {MfcInputBox},
    props: {
      value: {
        type: [File, Object],
      },
      src: {
        type: [String],
      },
      kind: {
        type: [String],
      },
      type: {
        type: [String],
      },
      showOnly: {
        type: Boolean,
        default: false
      },
      label: {
        type: String
      },
      errors: {
        type: String,
      }
    },
    data() {
      return {
        uploadedSrc: null,
        highlight: false,
        fileId: null,
      }
    },
    computed: {
      imgSrc() {
        return (this.cmpValue) ? (this.uploadedSrc || this.src) : false;
      },
      fileInputAttrs() {
        const {name, disabled, ...attrs} = this.attrs
        return attrs
      },
      uploading: {
        get() {
          return this.$store.state.attachmentUploading
        },
        set(v) {
          this.$store.commit('SET_STATE', {path: ['attachmentUploading'], value: v})
        }
      },
      withError() {
        return this.cmpErrors.length > 0
      }
    },
    methods: {
      async handleFile(files) {
        this.cmpErrors.length = 0;

        const file = first(files);

        if (!file || this.uploading) return;

        try {
          this.uploading = true;

          const formData = new FormData();

          formData.append('attachment[file]', file);
          formData.append('attachment[kind]', this.kind);
          formData.append('attachment[type]', this.type);

          const {data} = await this.$axios.post(this.$routes.attachments_path({format: "json"}), formData)

          if (data.resource) {
            this.cmpValue = data.resource.id
            this.uploadedSrc = data.resource.url
          }
        } catch (e) {
          this.cmpErrors = ['Непредвиденная ошибка']
        } finally {
          this.uploading = false;
        }
      },
      
      handleDrop(e) {
        this.stopDrag()

        if (this.showOnly) return

        const dt = e.dataTransfer
        const files = dt.files

        if (!isEmpty(files)) {
          this.handleFile(files)
        }
      },

      startDrag() {
        this.highlight = true
      },

      stopDrag() {
        this.highlight = false
      },

      removeDepartmentLogo(event) {
        event.stopPropagation();

        if (!this.cmpValue || this.uploading) return;

        this.cmpValue = this.uploadedSrc = null;
        this.$refs.file.value = '';
        this.$refs.resource_id.value = '';
      },
    },
    created () {
      if (this.value) this.cmpValue = this.value.id
      if (this.errors) this.cmpErrors = [this.errors]
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/styles/variables';
  @import '../../assets/styles/colours';

  .category_image {
    .drop-area {
      height: 128px;
      width: 180px;
    }
    .drop-area img {
      height: 128px;
      width: 180px;
      object-fit: cover;
      object-position: center;
    }
  }

  .drop-area {
    position: relative;
    border: 1px solid #ffffff;
    border-radius: $default-border-radius;
    background-color: #f5f5f5;
    height: 128px;
    width: 180px;
    overflow: hidden;
    transition: border .3s, background-color .3s;

    &.with-error {
      border-color: $error-color;
    }
    .label {
      color: #878787;
      align-self: flex-start;
      font-size: 16px;
      font-weight: 500;
      width: 100%;
    }

    .icon {
      $size: 48px;
      width: $size;
      height: $size;
      border-radius: 50%;
      background-color: #ffffff;
      align-self: flex-end;
      font-size: 19px;
      color: #948787;
      transition: background-color .3s;
    }

    .remove-logo-icon {
      z-index: 2;
      display: none;
      position: absolute;
      justify-content: flex-end;
      align-items: flex-start;
      width: 18px;
      height: 18px;
      margin-right: 6px;
      margin-top: 6px;
      opacity: 0.5;
      transition: opacity .3s;
    }

    &:not(.with-img) {
      padding: 11px;
    }

    &:hover {
      .remove-logo-icon {
        display: flex;
      }
      .remove-logo-icon::before {
        z-index: 2;
      }
      .remove-logo-icon:hover {
        opacity: 1;
      }
    }

    &.uploading {
      .remove-logo-icon {
        display: none;
      }
    }

    &:not(.show):not(.uploading) {
      cursor: pointer;

      &.highlight, &:hover {
        background-color: #ffffff;
        border-radius: 11px;
        border: 1px solid #dadada;

        .icon {
          background-color: #f5f5f5;
        }

        &.with-img {
          display: flex;
          justify-content: flex-end;
        }
      }
    }

    input {
      display: none;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      z-index: $passport-uploader-zindex;
    }
  }
</style>
